import axios from '../util/axiosConfig';


export const fetchAllRadiologistsAPI = async () => {
    return await axios.get(`/api/v1/radiologist`, {
    })
        .then(function (response) {

            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false };
        });
}